import { useEffect, useState } from 'react'
import { useAppAuth } from '@/contexts/app-auth.context'
import { knowledgeApiClient } from '@/lib/api'
import type { KnowledgeBaseOption } from '@super/node-graph-ui'

/**
 * Knowledge bases the editor offers on the graph and on a conversation node.
 * Super admins read the company the switcher selects; everyone else reads
 * their session company.
 */
export function useKnowledgeBases(): KnowledgeBaseOption[] {
  const { currentCompany, isSuperAdmin } = useAppAuth()
  const companyId = currentCompany?.id
  const [bases, setBases] = useState<KnowledgeBaseOption[]>([])

  useEffect(() => {
    let cancelled = false
    const load =
      isSuperAdmin && companyId
        ? knowledgeApiClient.getKnowledgeBasesForCompany(companyId)
        : knowledgeApiClient.getKnowledgeBases()
    void load.then(found => {
      if (cancelled) return
      setBases(found.map(base => ({ id: base.id, name: base.title })))
    })
    return () => {
      cancelled = true
    }
  }, [isSuperAdmin, companyId])

  return bases
}
